import AuthContext from "context/AuthContext";
import { useContext } from "react";
import ContainerIconValues from "./waste/ContainerIconValues";
import ContainerIconValuesBridge from "./bridge/ContainerIconValuesBridge";

const ContainerIconValuesManager = ({ item, lastMeasure }) => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case 'b':
            return (
                <ContainerIconValuesBridge item={item} lastMeasure={lastMeasure} />
            );
        default:
            return (
                <ContainerIconValues item={item} />
            );
    };
};
export default ContainerIconValuesManager;
